// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"624b47da","453":"9203d35d","667":"098d3a3e","946":"1ef7351c"}[chunkId] + ".chunk.js";
};